import React from "react";

let Scop = "./img/certificate.jpg";
let Certificate = "./img/Scope.pdf";

const Certificates = () => {
  return (
    <div>
      {/* Image Section */}

      <section className="bg-white py-5 lg:py-10 overflow-hidden w-[95%] mx-auto">
        <div className="flex justify-center items-center">
          <img
            src={Scop}
            alt="Scope"
            className="w-full md:w-[80%] lg:w-[60%] h-auto object-contain"
          />
        </div>
      </section>

      {/* PDF Viewer Section */}
      <section
        style={{
          backgroundColor: "white",
          padding: "20px 0",
          overflow: "hidden",
          width: "95%",
          margin: "0 auto",
        }}
      >
        <div
          style={{
            position: "relative",
            width: "100%",
            maxWidth: "800px", // Limit width on larger screens
            height: 0,
            paddingBottom: "56.25%", // Maintain 16:9 aspect ratio
            margin: "0 auto",
          }}
        >
          <iframe
            src={Certificate}
            title="PDF Viewer"
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              border: "none",
              display: "block",
            }}
          ></iframe>
        </div>
      </section>
    </div>
  );
};

export default Certificates;
